import Pending from '@app/store/action/pending';
import ActionHelper from '@module/redux-actions';
import API from '@app/api';

import Notification from '@app/store/action/notification';

export const actions = ActionHelper.types(['GET_INVOICES']);

export default ActionHelper.generate({
  getInvoices() {
    const pendingId = 'getInvoices';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.Invoices.getInvoices();

        dispatch({
          type: actions.GET_INVOICES,
          details: response.body,
        });
      } catch (error) {
        dispatch(
          Notification.setNotification('error', 'invoices_retrieve_exception')
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  getInvoice(downloadUrl) {
    const pendingId = 'getInvoice';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.Invoices.getInvoice(null, {
          pathExtValues: {
            downloadUrl,
          },
        });

        if (!response.body.url) {
          throw new Error('invoice_download_exception');
        }

        window.location = response.body.url;
      } catch (error) {
        dispatch(
          Notification.setNotification('error', 'invoice_download_exception')
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },
});
